import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export enum MenuIconVariant {
  MENU = 'menu',
  MENU_DARK = 'menu_dark',
  LIST = 'list',
  BUBBLE_CHAT = 'bubble_chat',
}
export interface IMenuIconProps extends IConDefaultType {
  variant?: MenuIconVariant;
}

function MenuIcon({ color, className, size = 24, rotate, flip, variant = MenuIconVariant.MENU }: IMenuIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === MenuIconVariant.MENU && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            d="M3.125 6C3.125 5.51675 3.51675 5.125 4 5.125H19.9999C20.4832 5.125 20.8749 5.51675 20.8749 6C20.8749 6.48325 20.4832 6.875 19.9999 6.875H4C3.51675 6.875 3.125 6.48325 3.125 6Z"
            fill={color}
          />
          <path
            d="M3.125 18C3.125 17.5168 3.51675 17.125 4 17.125H19.9999C20.4832 17.125 20.8749 17.5168 20.8749 18C20.8749 18.4832 20.4832 18.875 19.9999 18.875H4C3.51675 18.875 3.125 18.4832 3.125 18Z"
            fill={color}
          />
          <path
            d="M4 11.125C3.51675 11.125 3.125 11.5168 3.125 12C3.125 12.4832 3.51675 12.875 4 12.875H19.9999C20.4832 12.875 20.8749 12.4832 20.8749 12C20.8749 11.5168 20.4832 11.125 19.9999 11.125H4Z"
            fill={color}
          />
        </svg>
      )}
      {variant === MenuIconVariant.LIST &&
        (() => {
          const fill = color || EColorMap.gray_0;
          return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 18C7 17.4477 7.44772 17 8 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H8C7.44772 19 7 18.5523 7 18Z"
                fill={fill}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 6C7 5.44772 7.44772 5 8 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H8C7.44772 7 7 6.55228 7 6Z"
                fill={fill}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 12C7 11.4477 7.44772 11 8 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H8C7.44772 13 7 12.5523 7 12Z"
                fill={fill}
              />
              <path d="M4 6H4.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M4 12H4.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M4 18H4.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          );
        })()}
      {variant === MenuIconVariant.BUBBLE_CHAT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.0418 23.9578C5.75034 25.6663 8.5002 25.6663 13.9999 25.6663C19.4996 25.6663 22.2495 25.6663 23.958 23.9578C25.6666 22.2493 25.6666 19.4994 25.6666 13.9997C25.6666 8.49995 25.6666 5.75009 23.958 4.04155C22.2495 2.33301 19.4996 2.33301 13.9999 2.33301C8.5002 2.33301 5.75034 2.33301 4.0418 4.04155C2.33325 5.75009 2.33325 8.49995 2.33325 13.9997C2.33325 19.4994 2.33325 22.2493 4.0418 23.9578ZM21.8749 18.6663C21.8749 19.1496 21.4832 19.5413 20.9999 19.5413H6.99992C6.51667 19.5413 6.12492 19.1496 6.12492 18.6663C6.12492 18.1831 6.51667 17.7913 6.99992 17.7913H20.9999C21.4832 17.7913 21.8749 18.1831 21.8749 18.6663ZM20.9999 14.8747C21.4832 14.8747 21.8749 14.4829 21.8749 13.9997C21.8749 13.5164 21.4832 13.1247 20.9999 13.1247H6.99992C6.51667 13.1247 6.12492 13.5164 6.12492 13.9997C6.12492 14.4829 6.51667 14.8747 6.99992 14.8747H20.9999ZM21.8749 9.33301C21.8749 9.81626 21.4832 10.208 20.9999 10.208H6.99992C6.51667 10.208 6.12492 9.81626 6.12492 9.33301C6.12492 8.84976 6.51667 8.45801 6.99992 8.45801H20.9999C21.4832 8.45801 21.8749 8.84976 21.8749 9.33301Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
    </i>
  );
}

export default MenuIcon;
